import type { FeatureFlag } from 'constants/feature-flag';

export const featureFlagsNL: Record<FeatureFlag, boolean> = {
  addressValidation: false,
  availabilityBarf: false,
  calorieCalculator: false,
  cartCrossSellPopUp: true,
  cookieBot: true,
  crossSellCheckout: true,
  crossSellPdp: true,
  dynamicUxTest: true,
  ecoOption: true,
  expressCheckout: true,
  fube: true,
  klarna: false,
  localeSwitcher: false,
  loyaltyProgram: false,
  magazin: true,
  nutritionPlan: true,
  onDemandDelivery: true,
  otp: true,
  pdexEndpoints: false,
  petProfile: true,
  preventionNeed: true,
  reauth: false,
  savingsPlan: true,
  segmentation: true,
  subCrossSell: true,
};
